import { all } from 'redux-saga/effects'
import invoice from './invoice'
import user from './user'
import theme from './theme'
import school from './school'

export default function* root() {
  yield all([...invoice, ...user, ...theme, ...school])
}
